import React from 'react';
import { IndexRedirect, IndexRoute, Route } from 'react-router';
import AuthenticatedRoute from 'interactive-solutions/authentication/router/authenticated';
import UnauthenticatedRoute from 'interactive-solutions/authentication/router/unauthenticated';
import CoreLayout from 'layouts/CoreLayout/CoreLayout';
import LoginTabs from '../views/login-view/tabs/login-tabs';
import RegisterTabs from '../views/register-view/tabs/register-tabs';
import ForgotPasswordView from 'views/forgot-password-view/forgot-password-view';
import SetNewPassword from 'views/forgot-password-view/set-new-password';
import RegisterSettings from 'views/register-view/register-settings';
import ActivateAccount from 'views/activate-account/activate-account';
import ActivitiesView from 'views/activities-view/activities-view';
import InvoiceWrapper from 'views/economy-view/invoices/invoice-wrapper';
import Invoice from 'views/economy-view/invoices/invoice';
import PageWrapperContainer from 'layouts/page-wrapper/page-wrapper-container';
import Salaries from 'views/economy-view/salaries/salaries';
import EmployerCertificates from 'views/economy-view/employer-certificate/employer-certificates';
import EmployerCertificate from 'views/economy-view/employer-certificate/employer-certificate';
import AgreementsWrapper from 'views/economy-view/agreements/agreements-wrapper';
import AgreementHtml from 'views/economy-view/agreements/agreement-html';
import SupplierLedgers from 'views/economy-view/supplier-ledgers/supplier-ledgers';
import SupplierLedger from 'views/economy-view/supplier-ledgers/supplier-ledger';
import RegisterAssignment from '../views/economy-view/register-assignment/register-assignment';
import IncomeStatements from 'views/economy-view/income-statements/income-statements';
import Insurances from 'views/insurances/insurances';
import WorkingEnvironment from 'views/working-environment/working-environment';
import Customers from 'views/customers/customers';
import Customer from 'views/customers/customer';
import PaymentPage from 'views/payment/payment-page';
import PaymentStatusPage from 'views/payment/payment-status-page';
import PaymentCancel from 'views/payment/payment-cancel';
import SettingsWrapper from 'views/settings/settings-wrapper';
import PersonalInfo from 'views/settings/personal-info/personal-info';
import BankInfo from '../views/settings/salary-info/salary-info';
import OwnEmployment from 'views/settings/own-employment/own-employment';
import Faq from 'views/faq/faq';
import LoyaltyPointsView from 'views/loyalty-program/loyalty-points-container';
import ChangePassword from 'views/settings/change-password/change-password';
import InvoiceToolContainer from 'views/invoice-tool/invoice-tool-container';
import TokenLogin from 'views/token-login/token-login';
import LinkLogin from 'views/link-login/link-login';
import EIDLinkLogin from '../views/eid-link/eid-link-login';
import EIDLinkRegister from '../views/eid-link/eid-link-register';
import MissingView from 'views/missing-view/missing-view';
import NewsList from 'views/news-list/news-list';
import InvoiceCopy from 'views/invoice-copy/invoice-copy';
import AuthenticationService from '../interactive-solutions/authentication/service/authentication';
import {fetchCurrencies} from 'redux/modules/currencies';
import store from 'store';
import axios from 'axios';
import TaxkeyService from 'frilans-finans/taxkeys/taxkey-service';
import { UserService } from 'frilans-finans';
import UpdateCustomerEmail from 'views/bounced-email/update-customer-email';

const onLogout = () => {
  AuthenticationService.logout();
};

const onEnterInvoiceTool = () => {
  store.dispatch(fetchCurrencies());
};

const onEnterPotentiallyAuthenticatedRoutes = () => {
  axios.interceptors.request.use(AuthenticationService._requestInterceptor);
  axios.interceptors.response.use((response) => response, AuthenticationService._responseInterceptor);
};

const fetchUserAndTaxkeys = (nextState, replace, callback) => {
  UserService.get().promise.then(function (user) {
    TaxkeyService.get(user.id).then(callback).catch(callback);
  }).then(callback).catch(callback);
};

export default (store) => (
  <Route>
    <Route path='payment/cancel' component={PaymentCancel} />
    <Route path='payment/:uuid/status' component={PaymentStatusPage} />
    <Route path='payment/:uuid' component={PaymentPage} />
    <Route path='invoice-copy' component={InvoiceCopy} />
    <Route path='bounced-email/update-customer/:token' component={UpdateCustomerEmail} />

    <Route onEnter={onEnterPotentiallyAuthenticatedRoutes}>
      <Route path='/' component={CoreLayout}>
        <IndexRedirect to='activities'/>
        <Route path='set-new-password' component={SetNewPassword} />

        <UnauthenticatedRoute>
          <Route path='login' component={LoginTabs} />
          <Route path='register' component={RegisterTabs} />
          <Route path='forgot-password' component={ForgotPasswordView} />
          <Route path='activate-account' component={ActivateAccount} />
        </UnauthenticatedRoute>

        <AuthenticatedRoute>
          <Route path='logout' component={LoginTabs} onEnter={onLogout} />
        </AuthenticatedRoute>

        <Route path='token-login' component={TokenLogin} />
        <Route path='link-login/:token' component={LinkLogin} />
        <Route path='eid-link-login' component={EIDLinkLogin} />
        <Route path='eid-link-register' component={EIDLinkRegister} />

        <AuthenticatedRoute component={PageWrapperContainer}>
          <IndexRedirect to='activities' />
          <Route path='activities' component={ActivitiesView} />

          <Route path='economy'>
            <IndexRedirect to='invoices' component={InvoiceWrapper} />
            <Route path='invoices'>
              <IndexRoute component={InvoiceWrapper} />
              <Route path=':id' component={Invoice} />
            </Route>
            <Route path='salaries' component={Salaries} />
            <Route path='employercertificates'>
              <IndexRoute component={EmployerCertificates} />
              <Route path=':id' component={EmployerCertificate} />
            </Route>
            <Route path='agreements' component={AgreementsWrapper} />
            <Route path='supplier-ledgers'>
              <IndexRoute component={SupplierLedgers} />
              <Route path=':id' component={SupplierLedger} />
            </Route>
            <Route path='register-assignment' component={RegisterAssignment} />
            <Route path='incomestatements' component={IncomeStatements} />
            <Route path='loyalty-program'>
              <Route path='points' component={LoyaltyPointsView} />
            </Route>
          </Route>
          <Route path='insurances' component={Insurances} />
          <Route path='working-environment' component={WorkingEnvironment} />
          <Route path='customers'>
            <IndexRoute component={Customers} />
            <Route path=':id' component={Customer} />
          </Route>
          <Route path='settings' component={SettingsWrapper}>
            <IndexRedirect to='personal-information' />
            <Route path='personal-information' component={PersonalInfo} />
            <Route path='salary-information' component={BankInfo} />
            <Route path='own-employment' component={OwnEmployment} />
            <Route path='change-password' component={ChangePassword} />
          </Route>
          <Route path='faq' component={Faq} />
          <Route path='news' component={NewsList} />
        </AuthenticatedRoute>
      </Route>
      <AuthenticatedRoute onEnter={fetchUserAndTaxkeys}>
        <Route path='invoice-tool' component={InvoiceToolContainer} onEnter={onEnterInvoiceTool}/>
        <Route path='invoicetool' component={InvoiceToolContainer} onEnter={onEnterInvoiceTool}/>
        <Route path='invoice-tool(/:id)' component={InvoiceToolContainer} onEnter={onEnterInvoiceTool}/>
        <Route path='register-assignment' component={InvoiceToolContainer} onEnter={onEnterInvoiceTool} />
        <Route path='register-assignment(/:id)' component={InvoiceToolContainer} onEnter={onEnterInvoiceTool} />
        <Route path='registersettings' component={RegisterSettings} />
        <Route path='economy/agreements/:id' component={AgreementHtml} />
      </AuthenticatedRoute>
      <Route path='/' component={CoreLayout}>
        <Route path='*' component={MissingView} />
      </Route>
    </Route>
  </Route>
);



/** WEBPACK FOOTER **
 ** ./src/routes/index.js
 **/